import { render, staticRenderFns } from "./TableProductParent.vue?vue&type=template&id=c7e7560a"
import script from "./TableProductParent.vue?vue&type=script&lang=js"
export * from "./TableProductParent.vue?vue&type=script&lang=js"
import style0 from "./TableProductParent.vue?vue&type=style&index=0&id=c7e7560a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports